import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Grid } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import {
  SurveyDialogProps,
  TSTarTBackScreeningDefaultValues,
} from '../../type';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import STarTContents from './STarTContents';

import { updateSTarT } from 'apis/survey';

const STarTBackScreening = (
  props: SurveyDialogProps<TSTarTBackScreeningDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TSTarTBackScreeningDefaultValues) => {
    const { patient_id } = patientInfo;
    const { sb01, sb02, sb03, sb04, sb05, sb06, sb07, sb08, sb09 } = data;

    const request = {
      user_id,
      patient_id,
      contents: { ...data },
    };

    if (data.sb01 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb02 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb03 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb04 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb05 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb06 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb07 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb08 === undefined) return onRequired('REQUIRED.NONCHOICE');
    if (data.sb09 === undefined) return onRequired('REQUIRED.NONCHOICE');

    // console.log('데이터', data);
    updateSTarT(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('Đã được lưu lại.');
      })
      .catch(e => onFail('Lưu thất bại.', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          Sàng lọc STarT Back để phân nhóm điều trị mục tiêu cho bệnh nhân đau
          lưng cấp
          <Typography
            sx={{
              marginTop: '3px',
              marginBottom: '10px',
              fontWeight: '400',
              fontSize: '16px',
            }}
          >
            Hãy suy nghĩ lại về 2 tuần vừa qua và trả lời những câu hỏi sau.
          </Typography>
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <STarTContents {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default STarTBackScreening;
